export default __webpack_public_path__ + "static/media/Runescape.012325c5.jpg";